import { Text, Select, Input, FormControl, FormErrorMessage } from '@chakra-ui/react';
import type { PayerDocumentType, PaymentInformationWarnings } from '../common/paymentFormValidation';

type Props = {
  name: string;
  setName: (name: string) => void;
  documentType: PayerDocumentType;
  setDocumentType: (documentType: PayerDocumentType) => void;
  documentNumber: string;
  setDocumentNumber: (documentNumber: string) => void;
  email: string;
  setEmail: (email: string) => void;
  warnings?: PaymentInformationWarnings;
};

const PersonalInfo = ({
  name,
  setName,
  documentType,
  setDocumentType,
  documentNumber,
  setDocumentNumber,
  email,
  setEmail,
  warnings,
}: Props): JSX.Element => {
  return (
    <>
      <FormControl isInvalid={!!warnings?.name}>
        <Text fontWeight={600}>Nombre del Pagador</Text>
        <Input
          variant={'bankSelect'}
          placeholder="Nombre"
          onChange={(val) => setName(val.target.value)}
          value={name}
          name="name"
          id="payer-name"
          type="text"
          autoComplete="name"
        />
        <FormErrorMessage>{warnings?.name}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={!!warnings?.documentType}>
        <Text fontWeight={600}>Tipo de Documento</Text>
        <Select
          placeholder="Seleccionar"
          variant={'bankSelect'}
          onChange={(val) => setDocumentType(val.target.value as PayerDocumentType)}
          value={documentType}
          required
        >
          <option value={'cc'} style={{ color: '#3C3A45' }}>
            Cédula de Ciudadanía
          </option>
          <option value={'ce'} style={{ color: '#3C3A45' }}>
            Cédula de Extranjería
          </option>
          <option value={'nit'} style={{ color: '#3C3A45' }}>
            NIT
          </option>
          <option value={'ps'} style={{ color: '#3C3A45' }}>
            Pasaporte
          </option>
        </Select>
        <FormErrorMessage>{warnings?.documentType}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={!!warnings?.documentNumber}>
        <Text fontWeight={600}>Número de documento</Text>
        <Input
          variant={'bankSelect'}
          placeholder="Número de Documento"
          onChange={(val) => setDocumentNumber(val.target.value.trim())}
          value={documentNumber}
          name="document-number"
          id="document-number"
          type="text"
        />
        <FormErrorMessage>{warnings?.documentNumber}</FormErrorMessage>
      </FormControl>
      <FormControl isInvalid={!!warnings?.email}>
        <Text fontWeight={600}>Correo electrónico</Text>
        <Input
          variant={'bankSelect'}
          placeholder="Correo Electrónico"
          onChange={(val) => setEmail(val.target.value.trim())}
          value={email}
          name="email"
          id="payer-email"
          type="email"
          autoComplete="email"
        />
        <FormErrorMessage>{warnings?.email}</FormErrorMessage>
      </FormControl>
    </>
  );
};

export default PersonalInfo;
